// components/Location/Location.jsx
import React from 'react';
import './Location.css';

const Location = () => {
  // Tu ubicación real - DB ALAMBRADOS
  const locationData = {
    address: "DB ALAMBRADOS - Av. Ramón J. Cárcano 1175, X5152 Villa Carlos Paz, Córdoba",
    lat: -31.440033054177842,
    lng: -64.50320383045145,
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d851.0148369950721!2d-64.50320383045145!3d-31.440033054177842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x942d67b57bcdc8d9%3A0xd85a3633816b50b9!2sDB%20ALAMBRADOS!5e0!3m2!1ses!2sar!4v1754163206169!5m2!1ses!2sar"
  };

  const openInGoogleMaps = () => {
    // Usar el place_id específico de DB ALAMBRADOS para mayor precisión
    const googleMapsUrl = `https://www.google.com/maps/place/DB+ALAMBRADOS/@${locationData.lat},${locationData.lng},17z/data=!3m1!4b1!4m6!3m5!1s0x942d67b57bcdc8d9:0xd85a3633816b50b9!8m2!3d${locationData.lat}!4d${locationData.lng}!16s%2Fg%2F11y3_9_9_9`;
    window.open(googleMapsUrl, '_blank');
  };

  const openDirections = () => {
    // Usar el place_id específico para direcciones exactas
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=DB+ALAMBRADOS&destination_place_id=ChIJ2ciX-7VnpJURuVBrhTY2heM`;
    window.open(directionsUrl, '_blank');
  };

  return (
    <section id="ubicacion" className="section">
      <h2>NUESTRA UBICACIÓN</h2>
      
      {/* Dirección y botones */}
      <div className="location-header">
        <div className="address-info">
          <i className="fas fa-map-marker-alt"></i>
          <span>{locationData.address}</span>
        </div>
        <div className="map-buttons">
          <button className="map-btn primary" onClick={openInGoogleMaps}>
            <i className="fas fa-external-link-alt"></i>
            Abrir en Google Maps
          </button>
         
        </div>
      </div>

      {/* Mapa visible directamente con el nuevo iframe */}
      <div className="map-container">
        <iframe
          src={locationData.embedUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="DB ALAMBRADOS - Av. Ramón J. Cárcano 1175, Villa Carlos Paz"
          className="google-map"
        ></iframe>
      </div>
    </section>
  );
};

export default Location;